import React, { useState } from "react";
import { baseUrl } from "./baseUrl";
import { toast } from "react-toastify";
import axios from "axios";

const ConfirmModal = ({ item, setShow }) => {
    console.log(item);
    const [factorNumber, setFactorNumber] = useState("");
    const confirmHandler = () => {
        let data = new FormData();
        data.append("code", factorNumber);
        data.append("company_id", item.customer.id);
        let config = {
            method: "POST",
            url: `${baseUrl}/orders/confirm`,
            data: data,
        };
        axios(config)
            .then((response) => {
                setShow(false);
            })
            .catch(function (err) {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    return (
        <div className="factor-main">
            <div className="fac-modal">
                <span className="title">تایید فاکتور</span>
                <span className="name">{item.customer.store_name}</span>
                <span className="date">{item.Created_at}</span>
                <div className="inp-div">
                    <svg
                        width="41"
                        height="41"
                        viewBox="0 0 41 41"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M3.41663 15.3751V11.1042C3.41663 6.8505 6.85038 3.41675 11.1041 3.41675H15.375"
                            stroke="#F15A22"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M25.625 3.41675H29.8958C34.1496 3.41675 37.5833 6.8505 37.5833 11.1042V15.3751"
                            stroke="#F15A22"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M37.5834 27.3333V29.8958C37.5834 34.1495 34.1496 37.5833 29.8959 37.5833H27.3334"
                            stroke="#F15A22"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M15.375 37.5833H11.1041C6.85038 37.5833 3.41663 34.1496 3.41663 29.8958V25.625"
                            stroke="#F15A22"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <g opacity="0.4">
                            <path
                                d="M29.0416 16.2292V24.7709C29.0416 28.1876 27.3333 29.8959 23.9166 29.8959H17.0833C13.6666 29.8959 11.9583 28.1876 11.9583 24.7709V16.2292C11.9583 12.8126 13.6666 11.1042 17.0833 11.1042H23.9166C27.3333 11.1042 29.0416 12.8126 29.0416 16.2292Z"
                                stroke="#F15A22"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M32.4583 20.5H8.54163"
                                stroke="#F15A22"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </g>
                    </svg>

                    <input
                        type="text"
                        name="serial"
                        placeholder="سریال فاکتور"
                        onChange={(e) => setFactorNumber(e.target.value)}
                        value={factorNumber}
                    />
                </div>
                <div className="text-box-div"></div>
                <button onClick={confirmHandler} className="submit">
                    ثبت فاکتور
                </button>
            </div>
            <div className="menu">
                <ul>
                    <li>
                        <a href="./index.html">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M9.03125 3.84375L9.625 3.375V3.375C11.0175 2.27565 12.9825 2.27565 14.375 3.375L19.9786 7.79888C20.9394 8.55744 21.5 9.71422 21.5 10.9384V17.5C21.5 19.7091 19.7091 21.5 17.5 21.5H16C15.4477 21.5 15 21.0523 15 20.5V18.5M5.46875 6.65625L4.875 7.125L4.02142 7.79888C3.06058 8.55744 2.5 9.71422 2.5 10.9384L2.5 17.5C2.5 19.7091 4.29086 21.5 6.5 21.5H8C8.55228 21.5 9 21.0523 9 20.5V17.5C9 16.3954 9.89543 15.5 11 15.5H12"
                                    stroke="#D7D7D7"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                            </svg>
                            <span>خانه</span>
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M5 10H7C9 10 10 9 10 7V5C10 3 9 2 7 2H5C3 2 2 3 2 5V7C2 9 3 10 5 10Z"
                                    stroke="#D7D7D7"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M19 2H17C15 2 14 3 14 5V7C14 9 15 10 17 10H19C21 10 22 9 22 7V5"
                                    stroke="#D7D7D7"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M17 22H19C21 22 22 21 22 19V17C22 15 21 14 19 14H17C15 14 14 15 14 17V19C14 21 15 22 17 22Z"
                                    stroke="#D7D7D7"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M5 22H7C9 22 10 21 10 19V17C10 15 9 14 7 14H5C3 14 2 15 2 17V19"
                                    stroke="#D7D7D7"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>

                            <span>دسته بندی</span>
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M14.5 16H9.5"
                                    stroke="#D7D7D7"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M12.9 2.52009L12.87 2.59009L9.96995 9.32009H7.11995C6.43995 9.32009 5.78995 9.46009 5.19995 9.71009L6.94995 5.53009L6.98995 5.43009L7.05995 5.27009C7.07995 5.21009 7.09995 5.15009 7.12995 5.10009C8.43995 2.07009 9.91995 1.38009 12.9 2.52009Z"
                                    stroke="#D7D7D7"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M18.29 9.52002C17.84 9.38002 17.36 9.32002 16.88 9.32002H9.96997L12.87 2.59002L12.9 2.52002C13.05 2.57002 13.19 2.64002 13.34 2.70002L15.55 3.63002C16.78 4.14002 17.64 4.67002 18.16 5.31002C18.26 5.43002 18.34 5.54002 18.41 5.67002C18.5 5.81002 18.57 5.95002 18.61 6.10002C18.65 6.19002 18.68 6.28002 18.7 6.36002C18.97 7.20002 18.81 8.23002 18.29 9.52002Z"
                                    stroke="#D7D7D7"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M12 21.9998H8.1C7.86 21.9998 7.62 21.9798 7.39 21.9498C4.21 21.7398 2.51 20.0398 2.3 16.8598C2.27 16.6298 2.25 16.3898 2.25 16.1498V14.1998C2.25 12.1898 3.47 10.4598 5.21 9.70982C5.81 9.45982 6.45 9.31982 7.13 9.31982H16.89C17.38 9.31982 17.86 9.38982 18.3 9.51982C20.3 10.1198 21.76 11.9898 21.76 14.1898V16.1398C21.76 16.3398 21.75 16.5398 21.74 16.7398C21.55 20.2398 19.6 21.9998 15.9 21.9998"
                                    stroke="#D7D7D7"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M6.94999 5.52979L5.19999 9.70978C3.45999 10.4598 2.23999 12.1898 2.23999 14.1998V11.2698C2.23999 8.42979 4.25999 6.05979 6.94999 5.52979Z"
                                    stroke="#D7D7D7"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M21.76 11.2701V14.2001C21.76 12.0001 20.3 10.1301 18.3 9.5301C18.82 8.2301 18.97 7.2101 18.72 6.3601C18.7 6.2701 18.67 6.1801 18.63 6.1001C20.49 7.0601 21.76 9.0301 21.76 11.2701Z"
                                    stroke="#D7D7D7"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>

                            <span>کیف پول</span>
                        </a>
                    </li>
                    <li className="active">
                        <a href="./cart.html">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M2 3L3.04936 3.20987C3.91136 3.38227 4.55973 4.09732 4.6472 4.97203L4.8 6.5L5.7886 14.7383C5.90922 15.7435 6.76195 16.5 7.77435 16.5H16.7673C18.3733 16.5 19.7733 15.407 20.1628 13.8489L21.2855 9.35783C21.6485 7.90619 20.5505 6.5 19.0542 6.5H13.4H8.5"
                                    stroke="#D7D7D7"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M13 13.5H9"
                                    stroke="#D7D7D7"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <circle
                                    cx="8.5"
                                    cy="20"
                                    r="1.5"
                                    fill="#D7D7D7"
                                />
                                <circle
                                    cx="17.5"
                                    cy="20"
                                    r="1.5"
                                    fill="#D7D7D7"
                                />
                            </svg>

                            <span>سبد خرید</span>
                        </a>
                    </li>
                    <li>
                        <a href="./setting.html">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle
                                    cx="3"
                                    cy="3"
                                    r="3"
                                    transform="matrix(-1 0 0 1 15 9)"
                                    stroke="#D7D7D7"
                                    strokeWidth="1.5"
                                />
                                <path
                                    d="M17.7521 5.32987C18.0675 5.35581 18.3834 5.33129 18.6879 5.2595C19.016 5.18215 19.3774 5.24076 19.5967 5.49671C20.3979 6.4317 21.0294 7.51632 21.4437 8.70289C21.5689 9.0617 21.3868 9.44185 21.0935 9.68352C20.4257 10.2338 19.9999 11.0672 19.9999 12C19.9999 12.9328 20.4257 13.7662 21.0935 14.3165C21.3868 14.5581 21.5689 14.9383 21.4437 15.2971C21.0295 16.4835 20.398 17.5681 19.597 18.503C19.3776 18.759 19.0162 18.8176 18.6881 18.7402C17.9703 18.5709 17.1891 18.6643 16.5 19.0621C15.7501 19.4951 15.2579 20.2029 15.077 20.9848C15.001 21.3136 14.788 21.6122 14.4608 21.695C13.6735 21.8942 12.8491 22 11.9999 22C11.1508 22 10.3264 21.8942 9.53921 21.695C9.21202 21.6122 8.99904 21.3137 8.92299 20.9848C8.86969 20.7544 8.78935 20.5304 8.68334 20.318M15.3561 3.75789C15.2305 3.52319 15.1368 3.27319 15.0771 3.01511C15.001 2.68633 14.7881 2.38787 14.4609 2.30508C13.6736 2.10585 12.8492 2 11.9999 2C11.1508 2 10.3264 2.10584 9.53914 2.30504C9.21198 2.38783 8.999 2.6863 8.92293 3.01508C8.74203 3.79691 8.24979 4.5046 7.49999 4.9375C6.81097 5.33531 6.02974 5.42873 5.31201 5.25948C4.98394 5.18212 4.62253 5.24072 4.40321 5.49667C3.60204 6.43167 2.97049 7.5163 2.55625 8.70287C2.43099 9.06169 2.61307 9.44184 2.90639 9.68351C3.5742 10.2337 3.99998 11.0671 3.99998 12C3.99998 12.9329 3.5742 13.7663 2.90638 14.3165C2.61307 14.5582 2.43099 14.9383 2.55625 15.2971C2.97044 16.4836 3.6019 17.5681 4.40294 18.503C4.62228 18.759 4.98373 18.8176 5.31183 18.7402C5.65125 18.6601 6.00488 18.6388 6.35625 18.6807"
                                    stroke="#D7D7D7"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                            </svg>

                            <span>تنظیمات</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default ConfirmModal;
